import {
  MarkAssetVersionTasksReadDto,
  TaskControllerGetAssetVersionTasksLastReadParams
} from '@api/Api';
import { apiClient } from '@api/client';

export const taskGetAssetVersionTasksLastRead = (
  params: TaskControllerGetAssetVersionTasksLastReadParams,
  options?: Parameters<
    typeof apiClient.task.taskControllerGetAssetVersionTasksLastRead
  >[1]
) => apiClient.task.taskControllerGetAssetVersionTasksLastRead(params, options);

export const taskMarkAssetVersionTasksRead = (
  params: MarkAssetVersionTasksReadDto
) => apiClient.task.taskControllerMarkAssetVersionTasksRead(params);
